import { render, staticRenderFns } from "./StatsMarketing.vue?vue&type=template&id=49a93008&scoped=true"
import script from "./StatsMarketing.vue?vue&type=script&lang=js"
export * from "./StatsMarketing.vue?vue&type=script&lang=js"
import style0 from "./StatsMarketing.vue?vue&type=style&index=0&id=49a93008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a93008",
  null
  
)

export default component.exports